<template>
    <div>
        <van-list
            :v-model="loading"
            :finished="finished"
            :finished-text="text"
            @load="onload"
            >
            <div v-for="(item,index) in list" :key="index">
                <cell-order :info="item"></cell-order>
            </div>
        </van-list>
        <none v-if="list.length==0 && finished"></none>
    </div>
</template>

<script>
import cellOrder from '@/components/cellOrder'
import none from "@/components/none"
export default {
    props:["type"],
    data() {
        return {
            list:[],
            finished:false,
            loading:false,
            page:1,
            timer:null
        };
    },
    methods:{
        onload(){
            if(!this.timer){
                this.timer = setTimeout(() => {
                    if(this.$store.state.userInfo.user_type==1){
                        this.getUserList();
                    }else{
                        this.getList();       
                    }
                    // this.$store.state.userInfo.user_type==1
                    this.timer = null;
                }, 200)
            }
        },
        //普通会员获取订单列表
        getList(){
                let uid=this.$route.query;
                this.$https.fetchPost("order/index",{"page":this.page,"status":this.type},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    if(data.code==1 && data.data.length!=0){
                        this.list=[...this.list,...result.data.data];
                        this.loading= false;
                        this.page++;
                    }else{
                        this.finished= true;
                    }
                })
        },
        //经纪人获取用户订单列表
        getUserList(){
                let uid=this.$route.query.uid;
                console.log(uid,"经纪人获取用户订单列表")
                this.$https.fetchPost("user/getUserOrders",{"uid":uid},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    console.log(data,"/////////")
                    if(data.code==1){
                        this.list=[...this.list,...result.data.data];
                        this.loading= false;
                        this.page++;
                    }else{
                        this.finished= true;
                    }
                })
        }
    },
     computed:{
        text(){
            return this.list.length===0 ? '' : "没有更多了"
        }
    },
    components:{
        cellOrder,
        none
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/orderItem.vue